import * as React from "react";
import { useForm } from "react-hook-form";
import {
  Dimensions,
  FlatList,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Button} from "../../../components/core/Button";
import { useDispatch, useSelector } from "react-redux";
import { globalImport } from "../../../common/globalImports";
import { useNavigation } from "@react-navigation/native";
import { isMobile, openURL } from "../../../utils/commonMethods";
import {globalConfigurableData, globalConst, GlobalScreens} from "../../../utils/globalConstant";

const AddMoneyGST = ({ confirmDepositClick }) => {
  const navigation = useNavigation();

  const rechargeDetails1 = useSelector(({ wallet }) => wallet?.depositData);
  const rechargeDetails = rechargeDetails1?.data?.review;
  let knowMoreLink = useSelector(
    (state) =>
      state.utilReducer.globalConfigData?.depositConfig?.["INDIA"]?.knowMore
  );

  const confirmButtonClick = () => {
    confirmDepositClick(rechargeDetails1);
    if (isMobile()) {
      navigation.pop();
    }
  };

  const onKnowMoreBtnClick = () => {
    openURL(knowMoreLink);
  };

  //   rechargeDetails = {
  //     mainData: [
  //       {
  //         key: "Deposit Amount",
  //         value: 10000,
  //       },
  //       {
  //         key: "GST (28%)",
  //         value: 28000,
  //       },
  //       {
  //         key: "Cashback",
  //         value: 2800,
  //       },
  //       {
  //         key: "Final Amount",
  //         value: 10000,
  //       },
  //     ],
  //     subData: [
  //       {
  //         key: "In Deposit Wallet",
  //         value: 10000,
  //       },
  //       {
  //         key: "In Promo Wallet",
  //         value: 0,
  //       },
  //     ],
  //     percent: "100% Cashback",
  //     time: "fourth",
  //   };

  return (
    <>
      <View
        style={{
          //paddingHorizontal: 10,
          paddingVertical: 20,
          //width: width,
          flex: 1,
          justifyContent: "space-between",
        }}
      >
        <View>
          <View style={styles.tableContainer}>
            {rechargeDetails?.metadata?.map((item, index) => {
              return (
                <View
                  key={index}
                  style={[
                    styles.tableRow,
                    index === rechargeDetails?.metadata?.length - 1
                      ? { borderBottomWidth: 0, marginBottom: 0 }
                      : null,
                  ]}
                >
                  <Text style={styles.textFontStyle}>{item?.key}</Text>
                  <Text
                    style={[
                      styles.textFontStyle,
                      item?.key === "Cashback" || item.key === "Final Amount"
                        ? {
                            color:
                              item.key === "Cashback" ? globalConfigurableData.profitColor : globalConfigurableData.primaryTextColor1,
                            ...globalFontStyle.appFontSubTextBold,
                          }
                        : null,
                    ]}
                  >
                    {item?.value}
                  </Text>
                </View>
              );
            })}
            <View style={styles.gstTipInfoBlock}>
              {rechargeDetails?.split?.map((item, index) => {
                return (
                  <View
                    key={index}
                    style={[
                      styles.tableRow,
                      index === rechargeDetails?.split?.length - 1
                        ? { marginBottom: 0 }
                        : {
                            borderBottomWidth: 0.75,
                            borderColor: globalConfigurableData.borderColor,
                          },
                    ]}
                  >
                    <Text style={styles.textFontStyle}>{item?.key}</Text>
                    <Text style={styles.textFontStyle}>{item?.value}</Text>
                  </View>
                );
              })}
            </View>
          </View>

          {/*<View style={styles.knowMoreBlock}>*/}
          {/*  <Text style={[{ ...globalFontStyle.appFontHeading }, { flex: 1 }]}>*/}
          {/*    Get&nbsp;*/}
          {/*    <Text style={{ color: globalConfigurableData.profitColor }}>*/}
          {/*      {rechargeDetails?.gstCashbackPercent}% cashback*/}
          {/*    </Text>*/}
          {/*    &nbsp; on GST*/}
          {/*    <Text*/}
          {/*      style={{*/}
          {/*        ...globalFontStyle.appFontBody,*/}
          {/*        color: globalConfigurableData.secondaryTextColor1,*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      {"\n"}This is your {rechargeDetails?.depositNumber} deposit of*/}
          {/*      the {rechargeDetails?.depositNumberDuration}*/}
          {/*    </Text>*/}
          {/*  </Text>*/}

          {/*  <TouchableOpacity*/}
          {/*    onPress={onKnowMoreBtnClick}*/}
          {/*    style={styles.knowMoreBtn}*/}
          {/*  >*/}
          {/*    <Text*/}
          {/*      style={[*/}
          {/*        globalFontStyle.appFontSubText,*/}
          {/*        {*/}
          {/*          color: globalConfigurableData.primaryTextColor1,*/}
          {/*        },*/}
          {/*      ]}*/}
          {/*    >*/}
          {/*      {"Know More"}*/}
          {/*    </Text>*/}
          {/*  </TouchableOpacity>*/}
          {/*</View>*/}
        </View>

        <Button
          variant="primary"
          onPress={() => {
            setTimeout(() => {
              confirmButtonClick();
            }, globalConst.buttonTimer);
          }}
          style={{ flex: globalImport.isWeb ? {} : 0, marginTop: 15 }}
        >
          Confirm Request
        </Button>
      </View>
    </>
  );
};

export default AddMoneyGST;

const styles = StyleSheet.create({
  textFontStyle: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 13,
    paddingHorizontal: 18,
    paddingBottom: 10,
  },
  tableContainer: {
    borderWidth: 0.5,
    borderColor: GlobalScreens.AddMoney.borderColor,
    borderRadius: 6,
    //paddingHorizontal: 18,
    paddingVertical: 15,
    backgroundColor: globalConfigurableData.cardBgColor
  },
  gstTipInfoBlock: {
    backgroundColor: GlobalScreens.AddMoney.disclaimerConfigBgColor,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: globalConfigurableData.borderColor,
    //paddingHorizontal: 18,
    paddingTop: 15,
    marginTop: 10,

    marginHorizontal: 15,
  },
  knowMoreBtn: {
    paddingHorizontal: 15,
    paddingVertical: 8,
    backgroundColor: globalConfigurableData.globalThemeColor,
    borderColor: GlobalScreens.AddMoney.borderColor,
    borderWidth: 1,
    borderRadius: 100,
  },
  knowMoreBlock: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 15,
    paddingVertical: 15,
    alignItems: "center",
    backgroundColor: GlobalScreens.AddMoney.disclaimerConfigBgColor,
    borderRadius: 8,
  },
});
